/**
 * Created by Josef Jurca on 19.1.2018.
 */


class Reminder {

    /**
     * Constructs the instance.
     *
     * @param {Object} [options] - Options object.
     */
    constructor (options = {}) {

        this.id = options.id || '';
        this.name = options.name || '';
        this.assetId = options.assetId || '';

        return this;
    }
}

export default Reminder;


// WEBPACK FOOTER //
// ./src/js/models/reminder.js